<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"
        />

        <input-text
            name="name"
            label="* Name"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
        />

        <media-reference
            v-model="form.image"
            label="Image"
            name="image_id"
            class="mt-3"
            :language="form.language"
            :media-types="['Image']"
            :error="errors.payout_within_mins ? errors.payout_within_mins[0] : null"
        />

        <rocket-link
            :language="form.language"
            :resettable="true"
            :hide-link-text="true"
            v-model="form.image_link"
            class="mt-3"
            label="Image Link"
        />

        <input-rich-text
            name="content"
            label="Content"
            v-model="form.content"
            class="mt-3"
            :error="errors.content ? errors.content[0] : null"
            :maxlength="5000"
            :language="form.language"
        />

        <rocket-link
            :language="form.language"
            :resettable="true"
            v-model="form.button_link"
            class="mt-3"
            label="Button Link"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
import RocketLink from "./Link/RocketLink";

export default {
    name: "JumpNaviWithAuthorQuoteForm",
    components: {RocketLink},
    mixins: [crudForm],
    data() {
        return {
            form: {
                name: this.getFormData("name"),
                image: this.getFormData("image"),
                image_id: this.getFormData("image_id"),
                content: this.getFormData("content"),
                image_link: this.getFormData("image_link", {}),
                button_link: this.getFormData("button_link", {}),
            },
        };
    },
    watch: {
        "form.image": function (newValue) {
            this.form.image_id = newValue ? newValue.id : null;
        },
    }
};
</script>
